// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"c8b2ccf2","135":"c1b8f376","386":"4fc76f0d","562":"5135795d"}[chunkId] + ".chunk.js";
};